import { SORT_ORDER } from './constants';
export const setSortOrderArray = sortOrderArray => {
  try {
    window.localStorage.setItem(SORT_ORDER, sortOrderArray);
  } catch (e) {
    // do nothing
  }
};